import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PENDING, FAILURE, SUCCESS } from 'utils/constants/queryStatuses';
import { setKeyValue } from 'modules/keyValueStore/actions';
import { getFinanceCategories } from './api';

const STORE_KEY = 'financeCategories';

const fetchData = () => async (dispatch, getState) => {
  const { keyValueStore: { [STORE_KEY]: { status, data } = {} } } = getState();

  if (data || status === PENDING) {
    return;
  }

  try {
    dispatch(setKeyValue(STORE_KEY, { status: PENDING }));
    const categories = await getFinanceCategories();
    dispatch(setKeyValue(STORE_KEY, { status: SUCCESS, data: categories }));
  } catch {
    dispatch(setKeyValue(STORE_KEY, { status: FAILURE }));
  }
};

export const useFinanceCategories = () => {
  const dispatch = useDispatch();
  const { status, data } = useSelector((state) => state.keyValueStore[STORE_KEY]) ?? {};

  useEffect(() => {
    dispatch(fetchData());
  }, [dispatch]);

  return { status, data };
};
